import { render, staticRenderFns } from "./Changelang.vue?vue&type=template&id=695566f5&scoped=true&"
import script from "./Changelang.vue?vue&type=script&lang=js&"
export * from "./Changelang.vue?vue&type=script&lang=js&"
import style0 from "./Changelang.vue?vue&type=style&index=0&id=695566f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695566f5",
  null
  
)

export default component.exports